import { deriveProviderStatus } from './conversationHelpers'
import type { PendingDisclosure, ProviderStatusKind } from './types'
import './defendsphere-ai.css'

type TranslateFn = (key: string, fallback?: string) => string

const STATUS_COPY: Record<ProviderStatusKind, { key: string; fallback: string }> = {
  external_available: {
    key: 'complianceCenterUi.defendSphereAi.statusExternalAvailable',
    fallback: 'External AI available',
  },
  local_available: {
    key: 'complianceCenterUi.defendSphereAi.statusLocalAvailable',
    fallback: 'Local AI available',
  },
  approval_required: {
    key: 'complianceCenterUi.defendSphereAi.statusApprovalRequired',
    fallback: 'Approval required',
  },
  policy_blocked: {
    key: 'complianceCenterUi.defendSphereAi.statusPolicyBlocked',
    fallback: 'External processing blocked by policy',
  },
  not_configured: {
    key: 'complianceCenterUi.defendSphereAi.statusNotConfigured',
    fallback: 'Provider not configured',
  },
  temporarily_unavailable: {
    key: 'complianceCenterUi.defendSphereAi.statusUnavailable',
    fallback: 'Provider temporarily unavailable',
  },
  unknown: {
    key: 'complianceCenterUi.defendSphereAi.statusReady',
    fallback: 'DefendSphere AI ready',
  },
}

export function DefendSphereAiProviderStatus({
  pending,
  error,
  t,
}: {
  pending: PendingDisclosure | null
  error: string | null
  t: TranslateFn
}) {
  const kind = deriveProviderStatus(pending, error)
  const copy = STATUS_COPY[kind]
  return (
    <div className={`ds-ai-provider-status ds-ai-provider-status--${kind}`} role="status">
      <span className="ds-ai-provider-status__dot" aria-hidden />
      <span>{t(copy.key, copy.fallback)}</span>
    </div>
  )
}
